import React from 'react'
import { Modal } from "react-bootstrap";
import './OTPVerification.css';
import TextFieldComponent from './textFieldComponent';
import OTPComponent from './OTPComponent';

interface showModalProps {
    showModal: boolean;
    inputFieldSpinner: boolean;
    handleClose: () => void;
    handleInputFieldSubmit: (value: string) => Promise<boolean>;
    labelNameForTextField?: string;
    lengthOfTextField?: number;
    otpLabel: string,
    onOTPSubmit: (value: any) => void,
    otpLength: number,
    otpExpiryTime: number,
    otpRestartTimer: () => void,
    otpResetKey: number,
    otpShowSpinner: boolean,
    showError: boolean,
    setShowError: any,
    otpErrorMessage: string,
    otpRetryMessage: string,
    otpRetry: number,
    isTimeFinished: boolean,
    setIsTimeFinished: any,
    textFieldErrorMessage: string,
    textFieldIsError: boolean,
    setTextFieldIsError: any,
    showMobileNumberAlreadyLinked?: boolean;
    setShowMobileNumberAlreadyLinked?: any;
    contentToShow?: React.ReactNode;
    defaultInputValue?: string;
    showOTPComponent: boolean;
    setShowOTPComponent: any;
};
const OTPVerification = ({
    showModal,
    inputFieldSpinner,
    handleClose,
    handleInputFieldSubmit,
    labelNameForTextField,
    lengthOfTextField,
    otpLabel,
    onOTPSubmit,
    otpLength,
    otpExpiryTime,
    otpRestartTimer,
    otpResetKey,
    otpShowSpinner,
    showError,
    setShowError,
    otpErrorMessage,
    otpRetryMessage,
    otpRetry,
    isTimeFinished,
    setIsTimeFinished,
    textFieldErrorMessage,
    textFieldIsError,
    setTextFieldIsError,
    showMobileNumberAlreadyLinked=false,
    setShowMobileNumberAlreadyLinked,
    contentToShow,
    defaultInputValue='',
    showOTPComponent=false,
    setShowOTPComponent
}: showModalProps) => {
    function handleBackClick(): void {
        if (showOTPComponent) {
            setShowOTPComponent(false);
            return;
        }
        if(showMobileNumberAlreadyLinked){
            setShowMobileNumberAlreadyLinked(false);
            setTextFieldIsError(false);
            setShowOTPComponent(false);
            return;
        }
        setShowOTPComponent(false);
        handleClose();
    }

    function handleDiscardClick(): void {
        setShowOTPComponent(false);
        handleClose();
    }
    const handleTextFieldSubmit = async (value: string) => {

        const showOTP: any = await handleInputFieldSubmit(value);
        setShowOTPComponent(showOTP);
    }

    return (
        <>
            <div className="modal_verification_otp">
                <Modal
                    show={showModal}
                    onHide={() => handleDiscardClick()}
                    dialogClassName={'otp_verification_card_modal'}
                    centered={true}
                    backdrop="static"
                >
                    <Modal.Header>
                        <div style={{ display: "flex", justifyContent: "space-between", gap: "400px" }}>
                            <div className="d-flex align-items-center otp_verification__back_button" onClick={handleBackClick}>
                                <i className="bi bi-arrow-left" style={{ cursor: "pointer" }} ></i>
                                <span className="ms-1">Back</span>
                            </div>
                            <div className="d-flex align-items-center otp_verification_discard_button" onClick={handleDiscardClick}>
                                <span className="me-0">Discard</span>
                                <i className="bi bi-x" ></i>
                            </div>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <>
                            {showMobileNumberAlreadyLinked?
                            contentToShow:(
                            !showOTPComponent ?
                                <TextFieldComponent
                                    labelNameForTextField={labelNameForTextField}
                                    lengthOfTextField={lengthOfTextField}
                                    handleInputFieldSubmit={handleTextFieldSubmit}
                                    errorMessage={textFieldErrorMessage}
                                    isError={textFieldIsError}
                                    setIsError={setTextFieldIsError}
                                    inputFieldSpinner={inputFieldSpinner}
                                    defaultInputValue={defaultInputValue}
                                /> :
                                <OTPComponent
                                    otpLabel={otpLabel}
                                    onOTPSubmit={onOTPSubmit}
                                    otpLength={otpLength}
                                    otpExpiryTime={otpExpiryTime}
                                    otpRestartTimer={otpRestartTimer}
                                    resetKey={otpResetKey}
                                    showSpinner={otpShowSpinner}
                                    showError={showError}
                                    setShowError={setShowError}
                                    errorMessage={otpErrorMessage}
                                    retryMessage={otpRetryMessage}
                                    retry={otpRetry}
                                    isTimeFinished={isTimeFinished}
                                    setIsTimeFinished={setIsTimeFinished}
                                />)}
                        </>
                    </Modal.Body>
                </Modal>
            </div>
        </>
    );
};

export default OTPVerification;